import Layout from '../layout/Layout';
import Header from '../components/Header';
import Footer from '../components/Footer';
import OptimizedImage from '../components/OptimizedImage';
import DatosContacto from '../components/DatosContacto';
import React, { useEffect, useState, useMemo, lazy, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFirstImageUrl } from '../utils/imageUtils';
import { loadCSS } from '../utils/cssLoader';

// Lazy load heavy components
const ContactForm = lazy(() => import('../components/ContactForm'));



export default function Home() {

    const descripcionesServicios = {
        'Renta de Inmuebles': 'Gestión integral de rentas residenciales y comerciales con contratos transparentes, seguimiento personalizado y atención completa tanto para propietarios como inquilinos. Maximizamos la rentabilidad de tu inversión.',
        'Venta de Propiedades': 'Asesoría especializada en compra-venta de bienes raíces con evaluación de mercado, estrategias de marketing digital y acompañamiento legal completo. Garantizamos el mejor precio y proceso seguro.',
        'Compra': 'Te ayudamos a encontrar la propiedad ideal con análisis de mercado, negociación estratégica, verificación legal y financiamiento personalizado. Tu inversión en las mejores manos.',
        'Remates Bancarios': 'Especialistas en oportunidades de remate con asesoría legal completa, análisis de viabilidad, gestión de documentos y acompañamiento en todo el proceso de adjudicación bancaria.',
        'Administración de Propiedades': 'Gestión profesional de inmuebles con cobranza eficiente, mantenimiento preventivo, atención 24/7 a inquilinos y reportes detallados. Tranquilidad total para propietarios.',
        'Construcción y Mantenimiento': 'Servicios integrales de construcción, remodelación y mantenimiento con materiales de calidad, cronogramas precisos y supervisión profesional. Proyectos exitosos garantizados.',
    };

    const [properties, setProperties] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [index, setIndex] = useState(0);
    const [activeService, setActiveService] = useState(null);
    const [hoveredService, setHoveredService] = useState(null);
    const [isHovered, setIsHovered] = useState(false);
    const [direction, setDirection] = useState(1);

    const navigate = useNavigate();

    // Load CSS files for Home page
    useEffect(() => {
        loadCSS('home.css');
        loadCSS('loading.css');
        
        // Inyectar estilos críticos para DatosContacto inmediatamente
        const criticalStyles = `
            .contacto-container {
                position: relative !important;
                width: 100% !important;
                padding: 2rem 0 !important;
                font-family: 'Montserrat', 'Inter', sans-serif !important;
                display: block !important;
                visibility: visible !important;
                opacity: 1 !important;
                z-index: 999 !important;
            }
            .contacto {
                background: linear-gradient(135deg, 
                    rgba(255, 255, 255, 0.95) 0%, 
                    rgba(248, 250, 252, 0.9) 30%,
                    rgba(226, 232, 240, 0.85) 70%, 
                    rgba(219, 234, 254, 0.8) 100%) !important;
                backdrop-filter: blur(25px) saturate(1.2) !important;
                border-radius: 3.5rem !important;
                box-shadow: 
                    0 32px 64px rgba(0, 0, 0, 0.1),
                    0 16px 48px rgba(30, 64, 175, 0.15),
                    0 8px 32px rgba(59, 130, 246, 0.08),
                    inset 0 1px 0 rgba(255, 255, 255, 0.6),
                    inset 0 -1px 0 rgba(59, 130, 246, 0.1) !important;
                padding: 5rem 4rem !important;
                margin: 4rem auto !important;
                max-width: 1200px !important;
                border: 2px solid rgba(59, 130, 246, 0.15) !important;
                position: relative !important;
                overflow: hidden !important;
                display: block !important;
                visibility: visible !important;
                opacity: 1 !important;
                z-index: 100 !important;
            }
            .contacto-header {
                text-align: center !important;
                margin-bottom: 4rem !important;
                position: relative !important;
                z-index: 2 !important;
            }
            .contacto-header h2 {
                font-size: clamp(2.5rem, 6vw, 4rem) !important;
                font-weight: 800 !important;
                color: #10b981 !important;
                margin-bottom: 1.5rem !important;
                letter-spacing: -0.025em !important;
                font-family: 'Montserrat', 'Inter', sans-serif !important;
            }
            .contacto-subtitle {
                font-size: clamp(1.1rem, 3vw, 1.4rem) !important;
                color: #64748b !important;
                max-width: 600px !important;
                margin: 0 auto 2rem !important;
                line-height: 1.6 !important;
                font-weight: 400 !important;
            }
            .contacto-decoracion {
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 1rem !important;
                margin-bottom: 2rem !important;
            }
            .decoracion-punto {
                width: 8px !important;
                height: 8px !important;
                background: #10b981 !important;
                border-radius: 50% !important;
            }
            .decoracion-linea {
                width: 100px !important;
                height: 2px !important;
                background: linear-gradient(90deg, #10b981, #059669) !important;
            }
            .contacto-opciones {
                display: grid !important;
                grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)) !important;
                gap: 2rem !important;
                margin-bottom: 4rem !important;
                position: relative !important;
                z-index: 2 !important;
                visibility: visible !important;
                opacity: 1 !important;
            }
            .contacto-opcion {
                position: relative !important;
                transform: translateY(0) !important;
                transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1) !important;
            }
            .contacto-link {
                display: flex !important;
                align-items: center !important;
                padding: 2rem !important;
                background: rgba(255, 255, 255, 0.8) !important;
                border-radius: 2rem !important;
                text-decoration: none !important;
                color: inherit !important;
                box-shadow: 
                    0 16px 32px rgba(0, 0, 0, 0.08),
                    0 8px 24px rgba(16, 185, 129, 0.12) !important;
                border: 1px solid rgba(255, 255, 255, 0.5) !important;
                backdrop-filter: blur(15px) !important;
                transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1) !important;
                position: relative !important;
                overflow: hidden !important;
                visibility: visible !important;
                opacity: 1 !important;
                z-index: 10 !important;
            }
            .contacto-link:hover {
                transform: translateY(-4px) !important;
                box-shadow: 
                    0 24px 48px rgba(0, 0, 0, 0.12),
                    0 12px 32px rgba(16, 185, 129, 0.2) !important;
                background: rgba(255, 255, 255, 0.95) !important;
            }
            .contacto-icon-wrapper {
                width: 70px !important;
                height: 70px !important;
                background: linear-gradient(135deg, #10b981, #059669) !important;
                border-radius: 20px !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                margin-right: 1.5rem !important;
                position: relative !important;
                box-shadow: 0 8px 24px rgba(16, 185, 129, 0.3) !important;
            }
            .contacto-icon-wrapper svg {
                color: white !important;
            }
            .icon-pulse {
                position: absolute !important;
                top: 50% !important;
                left: 50% !important;
                width: 100% !important;
                height: 100% !important;
                border-radius: 20px !important;
                background: rgba(16, 185, 129, 0.4) !important;
                transform: translate(-50%, -50%) !important;
                animation: pulse 2s infinite !important;
            }
            @keyframes pulse {
                0% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
                70% { transform: translate(-50%, -50%) scale(1.4); opacity: 0; }
                100% { transform: translate(-50%, -50%) scale(1.4); opacity: 0; }
            }
            .contacto-info {
                flex: 1 !important;
            }
            .contacto-label {
                font-size: 1.25rem !important;
                font-weight: 700 !important;
                color: #1e293b !important;
                margin-bottom: 0.5rem !important;
                font-family: 'Montserrat', 'Inter', sans-serif !important;
            }
            .contacto-value {
                font-size: 1rem !important;
                color: #64748b !important;
                font-weight: 500 !important;
                margin: 0 !important;
            }
            .contacto-arrow {
                width: 40px !important;
                height: 40px !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                color: #64748b !important;
                transition: all 0.3s ease !important;
            }
            .contacto-link:hover .contacto-arrow {
                transform: translateX(4px) !important;
                color: #10b981 !important;
            }
            .contacto-footer {
                text-align: center !important;
                position: relative !important;
                z-index: 2 !important;
            }
            .contacto-cta {
                font-size: 1.1rem !important;
                color: #64748b !important;
                margin: 0 !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 0.5rem !important;
                font-weight: 500 !important;
            }
            .cta-icon {
                font-size: 1.25rem !important;
            }
            @media (max-width: 768px) {
                .contacto {
                    padding: 3rem 2rem !important;
                    margin: 2rem 1rem !important;
                    border-radius: 2.5rem !important;
                }
                .contacto-opciones {
                    grid-template-columns: 1fr !important;
                    gap: 1.5rem !important;
                }
                .contacto-link {
                    padding: 1.5rem !important;
                }
                .contacto-icon-wrapper {
                    width: 60px !important;
                    height: 60px !important;
                    margin-right: 1rem !important;
                }
            }
            
            /* Forzar visibilidad específicamente en página home */
            .contacto-container,
            .contacto,
            .contacto-opciones,
            .contacto-link,
            .contacto-opcion {
                display: block !important;
                visibility: visible !important;
                opacity: 1 !important;
                position: relative !important;
            }
            
            .contacto-opciones {
                display: grid !important;
            }
            
            .contacto-link {
                display: flex !important;
            }
            
            /* Reset conflicting styles para Home */
            section.contacto {
                all: unset !important;
                background: linear-gradient(135deg, 
                    rgba(255, 255, 255, 0.95) 0%, 
                    rgba(248, 250, 252, 0.9) 30%,
                    rgba(226, 232, 240, 0.85) 70%, 
                    rgba(219, 234, 254, 0.8) 100%) !important;
                backdrop-filter: blur(25px) saturate(1.2) !important;
                border-radius: 3.5rem !important;
                box-shadow: 
                    0 32px 64px rgba(0, 0, 0, 0.1),
                    0 16px 48px rgba(30, 64, 175, 0.15),
                    0 8px 32px rgba(59, 130, 246, 0.08),
                    inset 0 1px 0 rgba(255, 255, 255, 0.6),
                    inset 0 -1px 0 rgba(59, 130, 246, 0.1) !important;
                padding: 5rem 4rem !important;
                margin: 4rem auto !important;
                max-width: 1200px !important;
                border: 2px solid rgba(59, 130, 246, 0.15) !important;
                position: relative !important;
                overflow: hidden !important;
                display: block !important;
                visibility: visible !important;
                opacity: 1 !important;
                z-index: 100 !important;
            }
        `;
        
        // Crear e inyectar estilos
        const styleElement = document.createElement('style');
        styleElement.textContent = criticalStyles;
        styleElement.id = 'datos-contacto-home-styles';
        
        // Remover estilos previos si existen
        const existingStyles = document.getElementById('datos-contacto-home-styles');
        if (existingStyles) {
            existingStyles.remove();
        }
        
        document.head.appendChild(styleElement);
        
        // Cleanup function
        return () => {
            const styleToRemove = document.getElementById('datos-contacto-home-styles');
            if (styleToRemove) {
                styleToRemove.remove();
            }
        };
    }, []);

    // Animaciones al hacer scroll
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        }, observerOptions);

        // Observar elementos con animaciones
        const animatedElements = document.querySelectorAll('.animate-on-scroll');
        animatedElements.forEach((el) => observer.observe(el));

        // Agregar efecto parallax suave a la imagen
        const handleScroll = () => {
            const scrolled = window.pageYOffset;
            const parallaxElements = document.querySelectorAll('.asesoria-image');
            
            parallaxElements.forEach((element) => {
                const speed = 0.3; // Reducido de 0.5 a 0.3
                element.style.transform = `perspective(1000px) rotateX(1deg) translateY(${scrolled * speed * 0.05}px)`; // Reducido de 0.1 a 0.05
            });
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            animatedElements.forEach((el) => observer.unobserve(el));
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

  

    const destacadas = useMemo(() => {
        if (!Array.isArray(properties)) {
            console.log('❌ properties no es un array:', properties);
            return [];
        }
        const filtered = properties.filter(p => p.destacado === true);
        console.log('✨ Propiedades destacadas:', filtered.length);
        return filtered;
    }, [properties]);
    
    // Lógica del carrusel automático para mostrar 3 propiedades a la vez
    useEffect(() => {
        if (destacadas.length <= 3 || isHovered) return;
        
        const interval = setInterval(() => {
            setIndex((prevIndex) => {
                const maxIndex = destacadas.length - 3;
                if (direction === 1 && prevIndex >= maxIndex) {
                    setDirection(-1);
                    return prevIndex - 1;
                } else if (direction === -1 && prevIndex <= 0) {
                    setDirection(1);
                    return prevIndex + 1;
                }
                return prevIndex + direction;
            });
        }, 5000); // Cambio cada 5 segundos
        
        return () => clearInterval(interval);
    }, [destacadas.length, direction, isHovered]);

    useEffect(() => {
        // Usar la URL de la API directamente
        const apiUrl = 'https://inmobiliariaorsan.com.mx/api';
        
        console.log("API URL:", apiUrl);
        
        const fetchProperties = async () => {
            setLoading(true);
            setError(null);
            try {
                console.log('🔍 Intentando fetch a:', `${apiUrl}/propiedad`);
                const response = await fetch(`${apiUrl}/propiedad`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Origin': 'https://inmobiliariaorsan.com.mx'
                    },
                    cache: 'no-store',
                    credentials: 'same-origin'
                });
                
                console.log('📥 Response status:', response.status);
                console.log('📄 Response headers:', Object.fromEntries(response.headers.entries()));
                
                if (!response.ok) {
                    const text = await response.text();
                    console.error('❌ Response content:', text);
                    throw new Error(`HTTP error! status: ${response.status}, content: ${text.substring(0, 200)}...`);
                }
                
                const contentType = response.headers.get('content-type');
                if (!contentType || !contentType.includes('application/json')) {
                    const text = await response.text();
                    console.error('❌ Unexpected content type:', contentType);
                    console.error('❌ Response content:', text);
                    throw new Error(`Expected JSON but got ${contentType || 'unknown type'}`);
                }
                
                const data = await response.json();
                console.log('✅ Data received:', data);
                
                if (data && data.data && Array.isArray(data.data)) {
                    console.log('✅ Usando data.data array');
                    console.log('🔢 Total propiedades:', data.data.length);
                    console.log('⭐ Propiedades destacadas encontradas:', data.data.filter(p => p.destacado === true).length);
                    setProperties(data.data);
                } else if (Array.isArray(data)) {
                    console.log('✅ Usando data array directo');
                    console.log('🔢 Total propiedades:', data.length);
                    console.log('⭐ Propiedades destacadas encontradas:', data.filter(p => p.destacado === true).length);
                    setProperties(data);
                } else {
                    console.error('❌ Unexpected data structure:', data);
                    setProperties([]);
                }
                console.log('📸 Primera propiedad fotos:', data?.data?.[0]?.fotos || data?.[0]?.fotos || 'No hay fotos');
            } catch (error) {
                console.error('❌ Error fetching properties:', error);
                setError(error.message);
                setProperties([]);
            } finally {
                setLoading(false);
            }
        };

        fetchProperties();
    }, []);

    // Eliminado: ahora el scroll será manejado por CSS

    return (
        <Layout>
            <Header active="inicio" />
            <main className="home-container" style={{ fontFamily: "Inclusive Sans", flex: 1 }}>
            
                {loading ? (
                    <section className="loading-section">
                        <div className="loading-spinner">Cargando propiedades...</div>
                    </section>
                ) : error ? (
                    <section className="error-section">
                        <div className="error-message">
                            Lo sentimos, hubo un error al cargar las propiedades.
                            <br />
                            {process.env.NODE_ENV === 'development' && <small>{error}</small>}
                        </div>
                    </section>
                ) : (
                    <section
                        className="hero-carousel improved-carousel"
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <div className="carousel-track">
                            {destacadas.map((p, i) => {
                            console.log('🖼️ Propiedad fotos:', p.fotos);
                            const imgSrc = getFirstImageUrl(p.fotos);
                            console.log('🔗 URL de imagen:', imgSrc);
                            
                            // Determinar la posición relativa para animación y opacidad
                            let className = 'carousel-slide';
                            if (i === index) className += ' active';
                            else if (i === (index - 1 + destacadas.length) % destacadas.length) className += ' prev';
                            else if (i === (index + 1) % destacadas.length) className += ' next';
                            else className += ' hidden';
                            
                            return (
                                <div
                                    key={i}
                                    className={className}
                                    style={{ backgroundImage: `url(${imgSrc})`, cursor: 'pointer' }}
                                    onClick={() => navigate(`/propiedad/${p.id_propiedad}`)}
                                >
                                    <div className="carousel-overlay" />
                                    {i === index && (
                                        <div className="info-square">
                                            <h2 className="text-square" style={{ fontSize: '1.5rem', marginBottom: 6, animation: 'fadeInUp 1s cubic-bezier(.4,0,.2,1) 0.2s both' }}>{p.titulo?.toUpperCase()}</h2>
                                            <p className="price-square" style={{ fontSize: '1.2rem', marginBottom: 6, color: '#00921E', fontWeight: 'bold', animation: 'slideInFromLeft 0.8s cubic-bezier(.4,0,.2,1) 0.4s both' }}>${Number(p.precio).toLocaleString()} MXN</p>
                                            <p style={{ color: '#e0e0e0', fontSize: '1rem', marginBottom: 8, minHeight: 32, maxHeight: 48, overflow: 'hidden', animation: 'fadeInUp 1s cubic-bezier(.4,0,.2,1) 0.6s both' }}>{p.descripcion?.slice(0, 80) || ''}{p.descripcion?.length > 80 ? '...' : ''}</p>
                                            <button className="boton-blanco" onClick={() => navigate(`/propiedad/${p.id_propiedad}`)} style={{ animation: 'bounceIn 1s cubic-bezier(.4,0,.2,1) 0.8s both' }}>
                                                VER PROPIEDAD
                                            </button>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                        {/* Botones de navegación */}
                        <button
                            className="carousel-btn prev"
                            aria-label="Anterior"
                            onClick={() => {
                                setDirection(-1);
                                setIndex((index - 1 + destacadas.length) % destacadas.length);
                            }}
                        >
                            <OptimizedImage src="/flecha.png" alt="btn" style={{ height: '28px', rotate: "90deg" }} loading="eager" />
                        </button>
                        <button
                            className="carousel-btn next"
                            aria-label="Siguiente"
                            onClick={() => {
                                setDirection(1);
                                setIndex((index + 1) % destacadas.length);
                            }}
                        >
                            <OptimizedImage src="/flecha.png" alt="btn" style={{ height: '28px', rotate: "270deg" }} loading="eager" />
                        </button>
                        {/* Indicadores de posición */}
                        <div className="carousel-indicators">
                            {destacadas.map((_, idx) => (
                                <span
                                    key={idx}
                                    className={`carousel-dot${idx === index ? ' active' : ''}`}
                                    style={{ borderWidth: 2, borderStyle: 'solid', borderColor: idx === index ? '#00921E' : '#08395F', background: idx === index ? '#00921E' : '#fff8', width: 13, height: 13, display: 'inline-block', borderRadius: '50%', margin: '0 2px', transition: 'background 0.2s, border 0.2s' }}
                                    onClick={() => setIndex(idx)}
                                />
                            ))}
                        </div>
                    </div>
                </section>
                )}

                {/*Nueva Seccion: Asesoría Especializada*/}
                <section 
                    className="asesoria-section"
                    style={{ 
                        textAlign: 'center', 
                        backgroundColor: '#EEEEEF',
                        padding: 'clamp(6rem, 10vw, 8rem) clamp(1rem, 3vw, 2rem) clamp(4rem, 8vw, 6rem)',
                        minHeight: '70vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                        backgroundImage: 'url(/Orsan/frase.webp)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        marginTop: 'clamp(2rem, 4vw, 3rem)'
                    }}
                >
                    {/* Overlay decorativo más suave */}
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(135deg, rgba(8, 57, 95, 0.45) 0%, rgba(0, 146, 30, 0.35) 100%)',
                        pointerEvents: 'none',
                        zIndex: 1
                    }} />
                    
                    <div className="asesoria-content" style={{ 
                        maxWidth: '1000px',
                        width: '100%',
                        margin: '0 auto',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 'clamp(2rem, 4vw, 3rem)',
                        position: 'relative',
                        zIndex: 2
                    }}>
                        {/* Contenido principal centrado */}
                        <div className="asesoria-text" style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            maxWidth: '800px',
                            margin: '0 auto',
                            width: '100%'
                        }}>
                            <h2 style={{
                                fontSize: 'clamp(2rem, 5vw, 3rem)',
                                fontWeight: '900',
                                color: '#fff',
                                marginBottom: 'clamp(1.5rem, 3vw, 2rem)',
                                letterSpacing: '1px',
                                lineHeight: '1.2',
                                textAlign: 'center',
                                textShadow: '0 3px 12px rgba(0, 0, 0, 0.6)'
                            }}>
                                <span style={{ 
                                    color: '#ffd54f',
                                    textShadow: '0 3px 12px rgba(0, 0, 0, 0.6)'
                                }}>Asesoría Especializada</span>
                                <br />
                                en Bienes Raíces
                            </h2>
                            
                            <p style={{
                                fontSize: 'clamp(1.2rem, 3.5vw, 1.6rem)',
                                maxWidth: '700px',
                                textAlign: 'center',
                                lineHeight: '1.6',
                                marginBottom: 'clamp(2.5rem, 5vw, 3rem)',
                                color: '#fff',
                                fontWeight: '600',
                                letterSpacing: '0.5px',
                                background: 'rgba(255, 255, 255, 0.1)',
                                padding: 'clamp(2rem, 4vw, 2.5rem)',
                                borderRadius: '20px',
                                boxShadow: '0 6px 24px rgba(0, 0, 0, 0.2)',
                                border: '1px solid rgba(255, 255, 255, 0.15)',
                                backdropFilter: 'blur(8px)',
                                textShadow: '0 2px 6px rgba(0, 0, 0, 0.4)'
                            }}>
                                Ofrecemos asesoría especializada en compra, venta, renta y administración de propiedades con el respaldo de años de experiencia en el mercado inmobiliario
                            </p>
                            
                            <button 
                                onClick={() => navigate("/properties/")} 
                                className="responsive-button1 asesoria-button"
                                style={{
                                    fontSize: 'clamp(1.1rem, 3vw, 1.4rem)',
                                    padding: 'clamp(1.2rem, 3vw, 1.5rem) clamp(3rem, 6vw, 3.5rem)',
                                    borderRadius: '12px',
                                    boxShadow: '0 6px 18px rgba(0, 0, 0, 0.3)',
                                    transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                                    fontWeight: '800',
                                    letterSpacing: '1.5px',
                                    textTransform: 'uppercase',
                                    border: '2px solid rgba(255, 255, 255, 0.25)',
                                    cursor: 'pointer',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.75) 100%)',
                                    color: '#08395F',
                                    backdropFilter: 'blur(8px)'
                                }}
                            >
                                <span style={{ position: 'relative', zIndex: 1 }}>
                                    Ver Propiedades
                                </span>
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: '-100%',
                                    width: '100%',
                                    height: '100%',
                                    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                                    transition: 'left 0.6s ease',
                                    pointerEvents: 'none'
                                }} />
                            </button>
                        </div>
                    </div>
                </section>

                {/* Nueva sección: Encuentra Propiedades */}
                <section style={{ textAlign: 'center', padding: '3rem 1rem', backgroundColor: 'white' }} className="propiedades-section">
                    <h2 style={{ 
                        fontWeight: 'bold', 
                        fontSize: 'clamp(1.5rem, 4vw, 2.2rem)', 
                        color: '#00921E', 
                        letterSpacing: '-1px', 
                        marginBottom: 'clamp(2rem, 5vw, 3rem)', 
                        animation: 'fadeInUp 1s cubic-bezier(.4,0,.2,1)',
                        padding: '0 1rem'
                    }}>
                        Explora <span style={{ color: '#2A2929' }}>Nuestras Propiedades</span>
                    </h2>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 'clamp(1rem, 3vw, 2rem)',
                        maxWidth: '1200px',
                        margin: '0 auto',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        padding: '0 1rem',
                    }} className="ubicaciones-grid">
                        {[
                            { value: 'Xalapa', label: 'XALAPA', src: 'ver.webp' },
                            { value: 'Coatepec', label: 'COATEPEC', src: 'coatepec.webp' },
                            { value: 'Emiliano Zapata', label: 'EMILIANO ZAPATA', src: 'xalapa.webp' },
                            { value: 'Banderilla', label: 'BANDERILLA', src: 'Orsan/banderilla.webp' },
                            { value: 'Veracruz', label: 'VERACRUZ', src: 'Orsan/PUERTO.webp' },
                            { value: 'Puebla', label: 'PUEBLA', src: 'puebla.webp' }
                        ].map((item, i) => (
                            <div
                                key={i}
                                className="responsive-columns location-card"
                                onClick={() => {
                                    localStorage.setItem("ubicacion", item.value);
                                    // Agregar animación de clic
                                    const card = document.querySelectorAll('.location-card')[i];
                                    if (card) {
                                        card.style.transform = 'scale(0.95)';
                                        setTimeout(() => {
                                            card.style.transform = '';
                                            navigate("/properties/");
                                        }, 150);
                                    }
                                }}
                            >
                                <img 
                                    src={`${process.env.PUBLIC_URL || ''}/${item.src}`} 
                                    alt={item.label}
                                    loading="lazy"
                                    onError={(e) => {
                                        console.error(`Error cargando imagen: ${item.src}`, e);
                                        // Fallback para imágenes que no cargan
                                        e.target.style.backgroundColor = '#f0f0f0';
                                        e.target.style.display = 'flex';
                                        e.target.style.alignItems = 'center';
                                        e.target.style.justifyContent = 'center';
                                        e.target.innerHTML = `<span style="color: #666; font-size: 1.2rem;">${item.label}</span>`;
                                    }}
                                />
                                <div className="city-label">{item.label}</div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Servicios principales */}
                <section
                    style={{
                        backgroundColor: '#08395F',
                        color: 'white',
                        padding: 'clamp(2rem, 6vw, 4rem) clamp(1rem, 3vw, 2rem)',
                    }}
                >
                    {/* Título principal */}
                    <div style={{ textAlign: 'center', marginBottom: 'clamp(2rem, 5vw, 4rem)' }}>
                        <h2 className="servicios" style={{
                            maxWidth: '800px',
                            textAlign: 'center', 
                            fontSize: 'clamp(2rem, 5vw, 3.2rem)', 
                            lineHeight: 1.05, 
                            margin: '0 auto', 
                            fontWeight: 900, 
                            letterSpacing: '2px'
                        }}>
                            <span style={{ color: '#fff', fontWeight: 'bold' }}>CONOCE</span>
                            <span style={{ color: '#fff', fontWeight: 'bold' }}> NUESTROS </span>
                            <span style={{ color: '#fff', fontWeight: 'bold' }}>SERVICIOS</span>
                        </h2>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 'clamp(1.5rem, 4vw, 2rem)',
                        margin: '0 auto',
                        maxWidth: '1200px'
                    }}>
                        <div style={{ flex: '1 1 400px', minWidth: '300px' }}>
                            {[
                                'Venta de Propiedades',
                                'Renta de Inmuebles',
                                'Administración de Propiedades',
                                'Remates Bancarios',
                                'Construcción y Mantenimiento'
                            ].map((item, idx) => {
                                const isActive = activeService === item || hoveredService === item;

                                return (
                                    <div
                                        key={idx}
                                        style={{
                                            borderBottom: '1px solid white',
                                            marginBottom: '1rem',
                                            paddingBottom: '0.5rem',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => setActiveService(activeService === item ? null : item)}
                                        onMouseEnter={() => setHoveredService(item)}
                                        onMouseLeave={() => setHoveredService(null)}
                                    >
                                        <h3
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                fontSize: 'clamp(1.3rem, 3vw, 1.7rem)',
                                                userSelect: 'none',
                                                fontFamily: 'Montserrat',
                                                letterSpacing: '.5px',
                                                lineHeight: '1.2'
                                            }}
                                        >
                                            {item}
                                            <span style={{ fontSize: 'clamp(0.8rem, 2vw, 1rem)' }}>{activeService === item ? '▴' : '▾'}</span>
                                        </h3>

                                        <div
                                            style={{
                                                maxHeight: isActive ? '200px' : '0',
                                                overflow: 'hidden',
                                                transition: 'max-height 0.4s ease, opacity 0.4s ease',
                                                opacity: isActive ? 1 : 0
                                            }}
                                        >
                                            <p style={{ fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', marginTop: '0.5rem', color: '#ddd', lineHeight: '1.4' }}>
                                                {descripcionesServicios[item] || 'Descripción no disponible.'}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div style={{ flex: '1 1 400px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                            <OptimizedImage src="/casa2.webp" alt="Casa moderna representando nuestros servicios inmobiliarios" className='casa' style={{ 
                                maxWidth: 'min(600px, 90vw)', 
                                width: '100%', 
                                minWidth: 'min(300px, 70vw)', 
                                height: 'auto', 
                                boxShadow: '0 20px 60px rgba(8, 57, 95, 0.25), 0 12px 40px rgba(8, 57, 95, 0.15)', 
                                borderRadius: '2rem',
                                transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                                filter: 'brightness(1.05) saturate(1.1)',
                                border: '2px solid rgba(255, 255, 255, 0.2)'
                            }} />
                        </div>
                    </div>
                </section>

                {/*Frase 
                <section style={{ padding: '3rem 1rem', backgroundColor: '#f5f4f4', textAlign: 'center' }}>
                    <p style={{ fontStyle: 'italic', color: '#666', fontSize: '1.2rem' }}>
                        “Nuestra experiencia, compromiso y servicio integral
                        nos convierten en tu mejor aliado en el mundo inmobiliario”
                    </p>
                </section>*/}

                {/*Propiedades destacadas como carrusel (sección secundaria, sincronizada con el carrusel principal)*/}
                {/*Propiedades destacadas como grilla*/}
                <section
                    className="featured-section"
                    style={{ 
                        textAlign: 'center', 
                        padding: 'clamp(3rem, 6vw, 4rem) clamp(1rem, 3vw, 2rem)', 
                        backgroundColor: '#F8F9FA', 
                        alignItems: 'center', 
                        position: 'relative',
                        backgroundImage: 'linear-gradient(135deg, #F8F9FA 0%, #E9ECEF 100%)'
                    }}
                >
                    {/* Título mejorado con elementos decorativos */}
                    <div style={{
                        position: 'relative',
                        display: 'inline-block',
                        marginBottom: 'clamp(1rem, 3vw, 2rem)'
                    }}>
                        {/* Línea decorativa superior */}
                        <div style={{
                            position: 'absolute',
                            top: '-15px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '60px',
                            height: '3px',
                            background: 'linear-gradient(90deg, #00921E, #06B928)',
                            borderRadius: '2px'
                        }} />
                        
                        <h2 style={{ 
                            fontWeight: '900', 
                            fontSize: 'clamp(2rem, 5vw, 3rem)', 
                            marginBottom: '0', 
                            color: '#2A2929', 
                            animation: 'fadeInUp 1s cubic-bezier(.4,0,.2,1)',
                            padding: '0 1rem',
                            letterSpacing: '0.5px',
                            textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            position: 'relative',
                            background: 'linear-gradient(135deg, #2A2929 0%, #4A4A4A 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text'
                        }}>
                            PROPIEDADES{' '}
                            <span style={{ 
                                background: 'linear-gradient(135deg, #00921E 0%, #06B928 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                                fontWeight: '900',
                                position: 'relative'
                            }}>
                                DESTACADAS
                                {/* Efecto de brillo */}
                                <span style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%)',
                                    animation: 'shimmer 3s infinite',
                                    pointerEvents: 'none'
                                }} />
                            </span>
                        </h2>
                        
                        {/* Elementos decorativos laterales */}
                        <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '-80px',
                            transform: 'translateY(-50%)',
                            width: '40px',
                            height: '2px',
                            background: 'linear-gradient(90deg, transparent, #00921E)',
                            opacity: 0.6
                        }} />
                        <div style={{
                            position: 'absolute',
                            top: '50%',
                            right: '-80px',
                            transform: 'translateY(-50%)',
                            width: '40px',
                            height: '2px',
                            background: 'linear-gradient(90deg, #00921E, transparent)',
                            opacity: 0.6
                        }} />
                    </div>
                    
                    {/* Subtítulo mejorado */}
                    <div style={{
                        position: 'relative',
                        maxWidth: '600px',
                        margin: '0 auto clamp(2rem, 4vw, 3rem) auto'
                    }}>
                        <div style={{
                            color: '#6C757D',
                            textAlign: 'center',
                            fontFamily: 'Inclusive Sans',
                            fontSize: 'clamp(1.1rem, 3vw, 1.4rem)',
                            fontWeight: '500',
                            lineHeight: '1.6',
                            animation: 'fadeInUp 1s cubic-bezier(.4,0,.2,1) 0.2s both',
                            padding: 'clamp(1rem, 2vw, 1.5rem) clamp(1.5rem, 3vw, 2rem)',
                            background: 'linear-gradient(135deg, rgba(255,255,255,0.8) 0%, rgba(248,249,250,0.9) 100%)',
                            borderRadius: '16px',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                            border: '1px solid rgba(0,146,30,0.1)',
                            position: 'relative',
                            overflow: 'hidden'
                        }}>
                            {/* Icono decorativo */}
                            <span style={{
                                position: 'absolute',
                                top: '12px',
                                left: '16px',
                                fontSize: '1.2rem',
                                opacity: 0.3,
                                color: '#00921E'
                            }}>✨</span>
                            
                            Explora algunas de nuestras propiedades más solicitadas y encuentra tu hogar ideal
                            
                            {/* Elemento decorativo inferior */}
                            <div style={{
                                position: 'absolute',
                                bottom: 0,
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '50px',
                                height: '2px',
                                background: 'linear-gradient(90deg, transparent, #00921E, transparent)',
                                opacity: 0.5
                            }} />
                        </div>
                    </div>
                    
                    {/* Carrusel horizontal de propiedades destacadas */}
                    <div style={{
                        position: 'relative',
                        maxWidth: '1400px',
                        margin: '0 auto',
                        overflow: 'hidden',
                        padding: '0 clamp(1rem, 3vw, 2rem)'
                    }}>
                        {/* Contenedor del carrusel */}
                        <div 
                            style={{
                                display: 'flex',
                                transition: 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                                transform: `translateX(-${index * (100 / 3)}%)`,
                                gap: 'clamp(1rem, 2vw, 1.5rem)'
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            {destacadas.length > 0 ? destacadas.map((prop, idx) => {
                                const imgSrc = getFirstImageUrl(prop.fotos);
                                
                                return (
                                    <div key={prop.id_propiedad || idx} style={{
                                        flex: '0 0 calc(33.333% - 1rem)',
                                        minWidth: '300px',
                                        background: '#fff',
                                        borderRadius: '16px',
                                        overflow: 'hidden',
                                        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                                        transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                                        cursor: 'pointer',
                                        position: 'relative',
                                        animationDelay: `${idx * 0.1}s`,
                                        animation: `fadeInUp 0.8s cubic-bezier(.4,0,.2,1) both`,
                                        border: '1px solid rgba(0,146,30,0.08)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-4px) scale(1.01)';
                                        e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.15)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0) scale(1)';
                                        e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.12)';
                                    }}
                                    onClick={() => navigate(`/propiedad/${prop.id_propiedad}`)}
                                    >
                                        {/* Imagen de la propiedad */}
                                        <div style={{ position: 'relative', overflow: 'hidden' }}>
                                            <img
                                                src={imgSrc}
                                                alt={prop.titulo}
                                                style={{ 
                                                    width: '100%', 
                                                    height: '220px', 
                                                    objectFit: 'scale-down',
                                                    transition: 'transform 0.4s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = 'scale(1.05)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = 'scale(1)';
                                                }}
                                            />
                                            
                                            {/* Badge de modalidad */}
                                            <div style={{
                                                position: 'absolute',
                                                top: '12px',
                                                left: '12px',
                                                backgroundColor: '#B91C1C',
                                                color: 'white',
                                                padding: '6px 12px',
                                                borderRadius: '8px',
                                                fontSize: '0.875rem',
                                                fontWeight: '600',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px'
                                            }}>
                                                Venta
                                            </div>
                                            
                                            {/* Icono de favorito */}
                                            <div style={{
                                                position: 'absolute',
                                                top: '12px',
                                                right: '12px',
                                                width: '32px',
                                                height: '32px',
                                                backgroundColor: 'rgba(255,255,255,0.9)',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease'
                                            }}>
                                                <span style={{ fontSize: '16px', color: '#6B7280' }}>♡</span>
                                            </div>
                                        </div>
                                        
                                        {/* Contenido de la tarjeta */}
                                        <div style={{ padding: 'clamp(1rem, 2vw, 1.5rem)' }}>
                                            {/* Precio */}
                                            <div style={{
                                                fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
                                                fontWeight: '900',
                                                color: '#00921E',
                                                marginBottom: '8px',
                                                letterSpacing: '-0.5px'
                                            }}>
                                                ${Number(prop.precio).toLocaleString('es-MX')}
                                                <span style={{ 
                                                    fontSize: '0.875rem', 
                                                    color: '#6B7280', 
                                                    fontWeight: '500',
                                                    marginLeft: '4px'
                                                }}>MXN</span>
                                            </div>
                                            
                                            {/* Título */}
                                            <h3 style={{ 
                                                fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', 
                                                fontWeight: '700',
                                                color: '#1F2937',
                                                marginBottom: '8px',
                                                lineHeight: '1.3',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden'
                                            }}>
                                                {prop.titulo}
                                            </h3>
                                            
                                            {/* Ubicación */}
                                            {prop.ubicacion && (
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    marginBottom: '12px',
                                                    color: '#6B7280',
                                                    fontSize: '0.875rem'
                                                }}>
                                                    <span style={{ marginRight: '6px' }}>📍</span>
                                                    <span>{prop.ubicacion}</span>
                                                </div>
                                            )}
                                            
                                            {/* Características */}
                                            <div style={{
                                                display: 'flex',
                                                gap: '12px',
                                                marginBottom: '16px',
                                                fontSize: '0.875rem',
                                                color: '#6B7280'
                                            }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <span>🛏️</span>
                                                    <span>3</span>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <span>🚿</span>
                                                    <span>2</span>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <span>📐</span>
                                                    <span>120m²</span>
                                                </div>
                                            </div>
                                            
                                            {/* Botón de ver más */}
                                            <button style={{
                                                width: '100%',
                                                padding: '12px',
                                                backgroundColor: 'transparent',
                                                border: '2px solid #00921E',
                                                borderRadius: '8px',
                                                color: '#00921E',
                                                fontWeight: '600',
                                                fontSize: '0.875rem',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = '#00921E';
                                                e.target.style.color = 'white';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = 'transparent';
                                                e.target.style.color = '#00921E';
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(`/propiedad/${prop.id_propiedad}`);
                                            }}
                                            >
                                                Ver Detalles
                                            </button>
                                        </div>
                                    </div>
                                );
                            }) : (
                                <div style={{ 
                                    flex: '0 0 100%', 
                                    textAlign: 'center', 
                                    padding: '4rem',
                                    color: '#6B7280',
                                    fontSize: '1.125rem'
                                }}>
                                    No hay propiedades destacadas disponibles
                                </div>
                            )}
                        </div>
                        
                        {/* Controles de navegación */}
                        {destacadas.length > 3 && (
                            <>
                                <button
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        width: '48px',
                                        height: '48px',
                                        backgroundColor: 'rgba(255,255,255,0.95)',
                                        border: '1px solid rgba(0,0,0,0.1)',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                                        transition: 'all 0.3s ease',
                                        zIndex: 10
                                    }}
                                    onClick={() => {
                                        setDirection(-1);
                                        setIndex(index > 0 ? index - 1 : Math.max(0, destacadas.length - 3));
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#00921E';
                                        e.target.style.transform = 'translateY(-50%) scale(1.05)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'rgba(255,255,255,0.95)';
                                        e.target.style.transform = 'translateY(-50%) scale(1)';
                                    }}
                                >
                                    <span style={{ fontSize: '20px', color: '#374151' }}>‹</span>
                                </button>
                                
                                <button
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        width: '48px',
                                        height: '48px',
                                        backgroundColor: 'rgba(255,255,255,0.95)',
                                        border: '1px solid rgba(0,0,0,0.1)',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                                        transition: 'all 0.3s ease',
                                        zIndex: 10
                                    }}
                                    onClick={() => {
                                        setDirection(1);
                                        setIndex(index < destacadas.length - 3 ? index + 1 : 0);
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#00921E';
                                        e.target.style.transform = 'translateY(-50%) scale(1.05)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'rgba(255,255,255,0.95)';
                                        e.target.style.transform = 'translateY(-50%) scale(1)';
                                    }}
                                >
                                    <span style={{ fontSize: '20px', color: '#374151' }}>›</span>
                                </button>
                            </>
                        )}
                    </div>
                    
                    {/* Indicadores de página */}
                    {destacadas.length > 3 && (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '8px',
                            marginTop: 'clamp(1.5rem, 3vw, 2rem)'
                        }}>
                            {Array.from({ length: Math.max(1, destacadas.length - 2) }, (_, idx) => (
                                <button
                                    key={idx}
                                    style={{
                                        width: '12px',
                                        height: '12px',
                                        borderRadius: '50%',
                                        border: 'none',
                                        backgroundColor: idx === index ? '#00921E' : '#D1D5DB',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onClick={() => setIndex(idx)}
                                />
                            ))}
                        </div>
                    )}
                    
                    {/* Botón para ver todas las propiedades */}
                    <div style={{
                        textAlign: 'center',
                        marginTop: 'clamp(2rem, 4vw, 3rem)'
                    }}>
                        <button
                            onClick={() => navigate("/properties/")}
                            style={{
                                backgroundColor: '#00921E',
                                color: 'white',
                                border: 'none',
                                padding: 'clamp(1rem, 2vw, 1.25rem) clamp(2rem, 4vw, 2.5rem)',
                                borderRadius: '12px',
                                fontSize: 'clamp(1rem, 2.5vw, 1.125rem)',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                boxShadow: '0 4px 16px rgba(0,146,30,0.3)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#06B928';
                                e.target.style.transform = 'translateY(-1px)';
                                e.target.style.boxShadow = '0 6px 20px rgba(0,146,30,0.35)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#00921E';
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 16px rgba(0,146,30,0.3)';
                            }}
                        >
                            Explora nuestro inventario
                        </button>
                    </div>
                </section>

                <Suspense fallback={<div className="loading-fallback" style={{ padding: '2rem', textAlign: 'center' }}>Cargando formulario...</div>}>
                    <ContactForm titulo="Llena el Formulario para Comenzar el Proceso." frase="¿Deseas más información de nuestros servicios y deseas que un representante de Orsan Consorcio Inmobiliario te atienda?" />
                </Suspense>
                <hr />
                {/* Estilos críticos para DatosContacto */}
                <style dangerouslySetInnerHTML={{
                    __html: `
                        .contacto-container {
                            position: relative !important;
                            width: 100% !important;
                            padding: 2rem 0 !important;
                            font-family: 'Montserrat', 'Inter', sans-serif !important;
                        }
                        .contacto {
                            background: linear-gradient(135deg, 
                                rgba(255, 255, 255, 0.95) 0%, 
                                rgba(248, 250, 252, 0.9) 30%,
                                rgba(226, 232, 240, 0.85) 70%, 
                                rgba(219, 234, 254, 0.8) 100%) !important;
                            backdrop-filter: blur(25px) saturate(1.2) !important;
                            border-radius: 3.5rem !important;
                            box-shadow: 
                                0 32px 64px rgba(0, 0, 0, 0.1),
                                0 16px 48px rgba(30, 64, 175, 0.15),
                                0 8px 32px rgba(59, 130, 246, 0.08),
                                inset 0 1px 0 rgba(255, 255, 255, 0.6),
                                inset 0 -1px 0 rgba(59, 130, 246, 0.1) !important;
                            padding: 5rem 4rem !important;
                            margin: 4rem auto !important;
                            max-width: 1200px !important;
                            border: 2px solid rgba(59, 130, 246, 0.15) !important;
                            position: relative !important;
                            overflow: hidden !important;
                        }
                        .contacto-header {
                            text-align: center !important;
                            margin-bottom: 4rem !important;
                            position: relative !important;
                            z-index: 2 !important;
                        }
                        .contacto-header h2 {
                            font-size: clamp(2.5rem, 6vw, 4rem) !important;
                            font-weight: 800 !important;
                            color: #1e293b !important;
                            margin-bottom: 1.5rem !important;
                            letter-spacing: -0.025em !important;
                            font-family: 'Montserrat', 'Inter', sans-serif !important;
                        }
                        .contacto-subtitle {
                            font-size: clamp(1.1rem, 3vw, 1.4rem) !important;
                            color: #64748b !important;
                            max-width: 600px !important;
                            margin: 0 auto 2rem !important;
                            line-height: 1.6 !important;
                            font-weight: 400 !important;
                        }
                        .contacto-decoracion {
                            display: flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            gap: 1rem !important;
                            margin-bottom: 2rem !important;
                        }
                        .decoracion-punto {
                            width: 8px !important;
                            height: 8px !important;
                            background: #10b981 !important;
                            border-radius: 50% !important;
                        }
                        .decoracion-linea {
                            width: 100px !important;
                            height: 2px !important;
                            background: linear-gradient(90deg, #10b981, #059669) !important;
                        }
                        .contacto-opciones {
                            display: grid !important;
                            grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)) !important;
                            gap: 2rem !important;
                            margin-bottom: 4rem !important;
                            position: relative !important;
                            z-index: 2 !important;
                        }
                        .contacto-opcion {
                            position: relative !important;
                            transform: translateY(0) !important;
                            transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1) !important;
                        }
                        .contacto-link {
                            display: flex !important;
                            align-items: center !important;
                            padding: 2rem !important;
                            background: rgba(255, 255, 255, 0.8) !important;
                            border-radius: 2rem !important;
                            text-decoration: none !important;
                            color: inherit !important;
                            box-shadow: 
                                0 16px 32px rgba(0, 0, 0, 0.08),
                                0 8px 24px rgba(59, 130, 246, 0.12) !important;
                            border: 1px solid rgba(255, 255, 255, 0.5) !important;
                            backdrop-filter: blur(15px) !important;
                            transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1) !important;
                            position: relative !important;
                            overflow: hidden !important;
                        }
                        .contacto-link:hover {
                            transform: translateY(-4px) !important;
                            box-shadow: 
                                0 24px 48px rgba(0, 0, 0, 0.12),
                                0 12px 32px rgba(59, 130, 246, 0.2) !important;
                            background: rgba(255, 255, 255, 0.95) !important;
                        }
                        .contacto-icon-wrapper {
                            width: 70px !important;
                            height: 70px !important;
                            background: linear-gradient(135deg, #10b981, #059669) !important;
                            border-radius: 20px !important;
                            display: flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            margin-right: 1.5rem !important;
                            position: relative !important;
                            box-shadow: 0 8px 24px rgba(16, 185, 129, 0.3) !important;
                        }
                        .contacto-icon-wrapper svg {
                            color: white !important;
                        }
                        .icon-pulse {
                            position: absolute !important;
                            top: 50% !important;
                            left: 50% !important;
                            width: 100% !important;
                            height: 100% !important;
                            border-radius: 20px !important;
                            background: rgba(16, 185, 129, 0.4) !important;
                            transform: translate(-50%, -50%) !important;
                            animation: pulse 2s infinite !important;
                        }
                        @keyframes pulse {
                            0% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
                            70% { transform: translate(-50%, -50%) scale(1.4); opacity: 0; }
                            100% { transform: translate(-50%, -50%) scale(1.4); opacity: 0; }
                        }
                        .contacto-info {
                            flex: 1 !important;
                        }
                        .contacto-label {
                            font-size: 1.25rem !important;
                            font-weight: 700 !important;
                            color: #1e293b !important;
                            margin-bottom: 0.5rem !important;
                            font-family: 'Montserrat', 'Inter', sans-serif !important;
                        }
                        .contacto-value {
                            font-size: 1rem !important;
                            color: #64748b !important;
                            font-weight: 500 !important;
                            margin: 0 !important;
                        }
                        .contacto-arrow {
                            width: 40px !important;
                            height: 40px !important;
                            display: flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            color: #64748b !important;
                            transition: all 0.3s ease !important;
                        }
                        .contacto-link:hover .contacto-arrow {
                            transform: translateX(4px) !important;
                            color: #10b981 !important;
                        }
                        .contacto-footer {
                            text-align: center !important;
                            position: relative !important;
                            z-index: 2 !important;
                        }
                        .contacto-cta {
                            font-size: 1.1rem !important;
                            color: #64748b !important;
                            margin: 0 !important;
                            display: flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            gap: 0.5rem !important;
                            font-weight: 500 !important;
                        }
                        .cta-icon {
                            font-size: 1.25rem !important;
                        }
                        @media (max-width: 768px) {
                            .contacto {
                                padding: 3rem 2rem !important;
                                margin: 2rem 1rem !important;
                                border-radius: 2.5rem !important;
                            }
                            .contacto-opciones {
                                grid-template-columns: 1fr !important;
                                gap: 1.5rem !important;
                            }
                            .contacto-link {
                                padding: 1.5rem !important;
                            }
                            .contacto-icon-wrapper {
                                width: 60px !important;
                                height: 60px !important;
                                margin-right: 1rem !important;
                            }
                        }
                    `
                }} />
                <DatosContacto frase="Puedes agendar citas, enviar preguntas o solicitar asesoría de manera rápida." />
            </main>
            <div className="footer-wrapper">
                <Footer />
            </div>
            {/* Botón flotante de WhatsApp (desactivado)
            <a
                href="https://wa.me/+522283667786"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: 'fixed',
                    bottom: '30px',
                    right: '30px',
                    zIndex: 9999,
                    width: '60px',
                    height: '60px',
                    backgroundColor: '#25D366',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                    cursor: 'pointer'
                }}
            >
                <svg
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.485 3.485"
                        fill="white"
                    />
                </svg>
            </a>
            */}
        </Layout>
    );
}